import { useState } from "react"
import { techCards } from "../../data/data"

export default function TechCards() {
  const [cards] = useState(techCards)

  return (
    <>
      <section className="bg-blue py-10 lg:py-20">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-3 px-5 lg:max-w-4xl lg:mx-auto 2xl:px-0">
          {cards.map(({ id, title, image }) => (
            <article key={id} className="lg:mb-5">
              <img
                src={image}
                alt={title}
                title={title}
                className="block mx-auto lg:mb-5"
              />
              <h4 className="text-center mt-3 text-white uppercase">{title}</h4>
            </article>
          ))}
        </div>
      </section>
    </>
  )
}
